import { Linking, Platform } from 'react-native';

import { ActionButtonVariants } from 'components/action-button';
import { primitive } from 'styles/constants/primitives';
import { getConfigValue } from 'utils/environment';

import { CartDebugActionButton } from './cart-debug-action-button';

const buildSanityLink = (id: string) => {
  const env = getConfigValue({ key: 'env' });
  const region = getConfigValue({ key: 'country' });
  const sanityProjectId = getConfigValue({ key: 'sanityProjectId' });
  const query = `*%5B_id%3D%3D%22${id}%22%5D%0A&perspective=published`;
  return `https://${sanityProjectId}.api.sanity.io/vX/data/query/${env}_bk_${region.toLocaleLowerCase()}?query=${query}`;
};

const openExternalURL = (url: string) => {
  if (Platform.OS === 'web') {
    window.open(url, '_blank'); // Opens in a new tab on web
  } else {
    Linking.openURL(url); // Opens in the default browser on iOS/Android
  }
};

export const CartSanityButton = ({ id }: { id: string }) => {
  return (
    <CartDebugActionButton
      background={primitive.$blackOpacity10}
      variant={ActionButtonVariants.TEXT_ONLY}
      onPress={() => openExternalURL(buildSanityLink(id))}
    >
      sanity ➚
    </CartDebugActionButton>
  );
};
